import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "buttonLabel"]

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.buttonLabelTarget.textContent = "Copied"
    } catch (_error) {
      this.buttonLabelTarget.textContent = "Copy failed"
    }

    window.setTimeout(() => {
      this.buttonLabelTarget.textContent = "Copy link"
    }, 1500)
  }
}
